import { isNumericDataType } from "@/src/features/scores/lib/helpers";
import { isPresent, type ScoreConfigDomain } from "@langfuse/shared";

export function ScoreConfigDetails({ config }: { config: ScoreConfigDomain }) {
  const { name, description, minValue, maxValue, dataType } = config;
  const isNameTruncated = name.length > 20;

  return (
    <div className="bg-background p-2 text-xs text-wrap">
      {!!description && <p>{`Description: ${description}`}</p>}
      {isNumericDataType(dataType) &&
      (isPresent(minValue) || isPresent(maxValue)) ? (
        <p>{`Range: [${minValue ?? "-∞"}, ${maxValue ?? "∞"}]`}</p>
      ) : null}
      {isNameTruncated && <p>{`Full name: ${name}`}</p>}
    </div>
  );
}
